import {
	APP_INITIALIZER,
	NgModule
} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {
	HTTP_INTERCEPTORS,
	provideHttpClient,
	withInterceptorsFromDi
} from '@angular/common/http';
import {NgbNavModule} from "@ng-bootstrap/ng-bootstrap";
import {HttpAuthInterceptor} from "./shared/services/http-auth.interceptor";
import {LayoutModule} from "./layout/layout.module";
import {PagesModule} from "./pages/pages.module";
import {AppConfigFactory} from "./shared/services/config/app-config.factory";
import {AppConfigService} from "./shared/services/config/app-config.service";
import {FaviconService} from "./shared/services/favicon.service";

@NgModule({
	declarations: [
		AppComponent
	],
	bootstrap: [AppComponent],
	imports: [
		BrowserModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		NgbNavModule,
		LayoutModule,
		PagesModule
	],
	providers: [
		provideHttpClient(withInterceptorsFromDi()),
		{
			// Started here rather than once the app has booted, so the favicon is
			// requested while the page is still loading and Chrome's tab spinner covers it
			provide: APP_INITIALIZER,
			useFactory: (faviconService: FaviconService) => () => faviconService.init(),
			multi: true,
			deps: [FaviconService]
		},
		{
			provide: APP_INITIALIZER,
			useFactory: AppConfigFactory,
			multi: true,
			deps: [AppConfigService]
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: HttpAuthInterceptor,
			multi: true
		},

	]
})
export class AppModule {
}
